import {
  Box,
  Button,
  Heading,
  Spinner,
  Text,
  useToast
} from '@chakra-ui/react'
import { useMyScholarship } from '@olagg/api-hooks'
import { GameCredentials } from '@olagg/db-types'
import { useState } from 'react'
import { FaCheck, FaEdit } from 'react-icons/fa'
import { ICompletedFields } from '..'
import { IMultiStageModalContent } from '../../../interfaces/IMultiStageModalContent'
import { deleteObjectEmptyPositions } from '../utils'

interface IProps {
  completedFields: ICompletedFields
  credentials: GameCredentials
  setCurrentStep: (
    value: 'requestInfo' | 'confirmInfo' | 'success'
  ) => void
}

export const ConfirmInfo = ({
  completedFields,
  credentials,
  setCurrentStep,
}: IProps): IMultiStageModalContent => {
  const toast = useToast()

  const [isLoading, setIsLoading] = useState(false)

  const { updateCredentials } = useMyScholarship()

  const onClickConfirm = () => {
    setIsLoading(true)
    const data: Partial<GameCredentials> =
      deleteObjectEmptyPositions(completedFields)

    updateCredentials(credentials.id, data)
      .then(() => setCurrentStep('success'))
      .catch(e => {
        toast({
          title: 'Error',
          colorScheme: 'olaggYellow',
          status: 'error',
          description: e.message,
          position: 'bottom-right',
          duration: 2000,
          isClosable: true
        })
      })
      .finally(() => setIsLoading(false))
  }
  return {
    body: (
      <>
        <Heading fontSize="24px" color="olaggPurple.100" pb={4}>
          ¡Ya estamos próximos!
        </Heading>
        <Text
          fontSize="16px"
          lineHeight="24px"
          fontFamily="text"
          mb={5}
        >
          Confirmar los datos ingresados:
        </Text>
        {Object.keys(completedFields).map((key, index) => {
          if (completedFields[key as keyof ICompletedFields])
            return (
              <Box
                key={index}
                mt={5}
                borderBottom="2px"
                borderColor="gray.300"
              >
                <Text color="gray.500">
                  {
                    completedFields[
                    key as keyof ICompletedFields
                    ]
                  }
                </Text>
              </Box>
            )
        })}
      </>
    ),
    footer: (
      <Box px={1} w="full">
        <Button
          variant="filledGradient"
          leftIcon={!isLoading ? <FaCheck /> : undefined}
          w="full"
          onClick={onClickConfirm}
        >
          {!isLoading ? 'Continuar' : <Spinner />}
        </Button>
        <Button
          mt={5}
          variant="outlinedGradient"
          color="olaggPink.100"
          leftIcon={<FaEdit />}
          w="full"
          onClick={() => setCurrentStep('requestInfo')}
        >
          Modificar Datos
        </Button>
      </Box>
    )
  }
}
